import { render, staticRenderFns } from "./search-object.vue?vue&type=template&id=f5559afc&scoped=true&"
import script from "./search-object.vue?vue&type=script&lang=js&"
export * from "./search-object.vue?vue&type=script&lang=js&"
import style0 from "./search-object.vue?vue&type=style&index=0&id=f5559afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5559afc",
  null
  
)

export default component.exports